import React from 'react';
import { useTranslation } from 'react-utilities';
import { TPunishment } from '../../utils/types';
import { NAPageItemConfigType, PageItemRenderingProps } from '../ConfigTypes';

/**
 * Notes moderators left when making a consequence decision
 */
const ModeratorNotePageItem = (props: PageItemRenderingProps): JSX.Element => {
  const { translate } = useTranslation();
  const { punishmentData } = props;

  return (
    <div data-testid='moderator-note'>
      {/* eslint-disable-next-line react/jsx-no-literals */}
      {translate('Messages.ModeratorNoteTitle')}: <b>{punishmentData.messageToUser}</b>
    </div>
  );
};

const ModeratorNotePageItemConfig: NAPageItemConfigType = {
  getIsVisible: (punishmentData: TPunishment) => {
    return !punishmentData.verificationCategory;
  },
  renderComponent: ModeratorNotePageItem,
  configName: 'moderator-note'
};

export default ModeratorNotePageItemConfig;
